// src/utils/square-utils.js

// Keep track if we've already loaded Square to prevent multiple script loads
let squarePromise = null;

export const loadSquareSdk = () => {
  // If we already have a loading promise, return that instead of creating a new one
  if (squarePromise) {
    return squarePromise;
  }
  
  // Create a new promise for loading Square
  squarePromise = new Promise((resolve, reject) => {
    // Check if Square SDK is already loaded
    if (window.Square) {
      resolve(window.Square);
      return;
    }
    
    // Check if the script is already in the DOM but not fully loaded
    const existingScript = document.querySelector('script[src*="square.js"]');
    if (existingScript) {
      existingScript.addEventListener('load', () => {
        if (window.Square) {
          resolve(window.Square);
        } else {
          reject(new Error('Square SDK loaded but Square object not found'));
        }
      });
      existingScript.addEventListener('error', () => {
        reject(new Error('Failed to load Square SDK'));
        squarePromise = null; // Reset promise on error
      });
      return;
    }
    
    // Create script element to load Square SDK - UPDATED FOR PRODUCTION
    const script = document.createElement('script');
    script.src = 'https://web.squarecdn.com/v1/square.js'; // Changed from sandbox URL
    script.crossOrigin = 'anonymous';
    script.id = 'square-sdk-script'; // Add ID for easier identification
    
    script.onload = () => {
      if (window.Square) {
        console.log('Square SDK loaded successfully (Production)');
        resolve(window.Square);
      } else {
        squarePromise = null; // Reset promise on error
        reject(new Error('Square SDK loaded but Square object not found'));
      }
    };
    
    script.onerror = () => {
      squarePromise = null; // Reset promise on error
      reject(new Error('Failed to load Square SDK'));
    };
    
    document.body.appendChild(script);
  });
  
  return squarePromise;
};

// Add a helper function to clean up Square elements - IMPROVED VERSION
export const cleanupSquareElements = () => {
  // Find all Square inputs and remove them
  const squareSelectors = [
    '.sq-input', 
    '.sq-payment-form', 
    '.sq-input-label', 
    '.sq-input-container',
    '.sq-input-field',
    '.sq-card-iframe-container'
  ];
  
  squareSelectors.forEach(selector => {
    const elements = document.querySelectorAll(selector);
    elements.forEach(el => {
      if (el && el.parentNode) {
        try {
          el.parentNode.removeChild(el);
        } catch (e) {
          // Ignore if element is already removed
        }
      }
    });
  });
  
  // Clean up any existing Square card containers
  const existingContainers = document.querySelectorAll('[id^="square-card-container"]');
  existingContainers.forEach(container => {
    if (container) {
      container.innerHTML = '';
    }
  });
};